import { createContext, useState, useEffect, useCallback, useRef } from 'react';
const EventContext = createContext(null);

const EventContextProvider = ({ children }) => {

    const [event, setEvent] = useState(null);
    const timeoutRef = useRef(null);

    const createEvent = useCallback((new_event) => {
        setEvent(new_event);
    }, []);

    const removeEvent = useCallback(() => {
        setEvent(null);
    }, []);

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }

        if (event && event.timeOut) {
            timeoutRef.current = setTimeout(() => {
                removeEvent();
            }, parseInt(event.timeOut, 10));
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [event, removeEvent]);

    return <EventContext.Provider value={{ event, createEvent, removeEvent }}>
        { children }
    </EventContext.Provider>
};

export { EventContext };
export default EventContextProvider;